/**
 * StoreRegisterPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  KakaoMap,
  UploadFile,
} from 'components';
import { Select, Input, Button, Radio } from 'antd';
import { openAddressModal } from 'utils/DaumAPIManager';
import Formatter from 'utils/Formatter';

const StoreRegisterPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    storeNameRef,
    storeContentRef,
    storeAddressRef,
    accountRef,
    passwordRef,
    rePasswordRef,
    nameRef,
    phoneRef,
    emailRef,
    inputValue,
    setInputValue,
    informationValue,
    setInformationValue,
    adminInfo,
    setAdminInfo,
    emailAddress,
    onChange,
    onCoordChange,
    address,
    setAddress,
    onSubmit,
    onCancel,
    onDuplication,
    files,
    onThumbnailFileChange,
    onMenuFileChange,
    onStoreFileChange,
    onLicenseFileChange,
    onEtcFileChange,
  } = props;
  /* ===== STATE ===== */

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    linkButton: {
      border: 'none',
      background: 'none',
      fontSize: 12,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  };

  const defaultForm = [
    {
      label: '매장명',
      required: true,
      form: [
        {
          input: (
            <Input
              ref={storeNameRef}
              size="large"
              value={inputValue.shop_information_name}
              onChange={(e) =>
                onChange(
                  'shop_information_name',
                  e.target.value,
                  inputValue,
                  setInputValue
                )
              }
              placeholder="매장명을 입력해주세요"
              showCount
              count={{
                max: 20,
                show: true,
              }}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '매장 설명',
      required: true,
      form: [
        {
          input: (
            <Input.TextArea
              ref={storeContentRef}
              size="large"
              value={inputValue.shop_information_content}
              onChange={(e) =>
                onChange(
                  'shop_information_content',
                  e.target.value,
                  inputValue,
                  setInputValue
                )
              }
              placeholder="매장 설명을 입력해주세요"
              showCount
              count={{
                max: 100,
                show: true,
              }}
              autoSize={{ minRows: 4, maxRows: 6 }} // 텍스트 영역의 높이를 자동으로 조정
              style={{
                ...styles.form.input.large,
                width: 500,
                height: 'auto', // 높이를 자동 조정
                marginBottom: 10,
              }}
            />
          ),
        },
      ],
    },
    {
      label: '주소',
      required: true,
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                ref={storeAddressRef}
                size="large"
                value={inputValue.shop_information_postcode}
                placeholder="우편번호"
                readOnly
                style={{ width: 300 }}
              />
              <Button size="large" onClick={() => handleOpen()}>
                주소찾기
              </Button>
            </>
          ),
        },
        {
          input: (
            <>
              <Input
                ref={storeAddressRef}
                size="large"
                value={inputValue.shop_information_address}
                placeholder="주소"
                readOnly
                style={{ width: 500 }}
              />
            </>
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                value={inputValue.shop_information_address_detail}
                onChange={(e) =>
                  onChange(
                    'shop_information_address_detail',
                    e.target.value,
                    inputValue,
                    setInputValue
                  )
                }
                placeholder="상세주소"
                style={{ width: 500 }}
              />
            </>
          ),
        },
        {
          input: (
            <>
              <KakaoMap
                width={500}
                address={inputValue.shop_information_address}
                name={inputValue.shop_information_name}
                onChange={(lat, lng) => onCoordChange(lat, lng)}
              />
            </>
          ),
        },
      ],
    },
  ];

  const infoFileForm = [
    {
      label: '매장 썸네일',
      form: [
        {
          input: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                padding: '20px 0px',
              }}
            >
              <UploadFile
                files={files.thumbnail}
                preview
                multiple
                max={1}
                onChange={onThumbnailFileChange}
              />
            </div>
          ),
        },
      ],
    },
    // {
    //   label: '메뉴판',

    //   form: [
    //     {
    //       input: (
    //         <div
    //           style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             flexWrap: 'wrap',
    //             padding: '20px 0px',
    //           }}
    //         >
    //           <UploadFile
    //             files={files.menu}
    //             preview
    //             multiple
    //             max={1}
    //             onChange={onMenuFileChange}
    //           />
    //         </div>
    //       ),
    //     },
    //   ],
    // },
    {
      label: '매장 사진',
      form: [
        {
          input: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                padding: '20px 0px',
              }}
            >
              <UploadFile
                files={files.store}
                preview
                multiple
                max={5}
                onChange={onStoreFileChange}
              />
            </div>
          ),
        },
      ],
    },
    {
      label: '사업자등록증',
      required: true,
      form: [
        {
          input: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                padding: '20px 0px',
              }}
            >
              <UploadFile
                files={files.license}
                preview
                multiple
                max={1}
                onChange={onLicenseFileChange}
              />
            </div>
          ),
        },
      ],
    },
    // {
    //   label: '기타',
    //   form: [
    //     {
    //       input: (
    //         <div
    //           style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             flexWrap: 'wrap',
    //             padding: '20px 0px',
    //           }}
    //         >
    //           <UploadFile
    //             files={files.etc}
    //             preview
    //             multiple
    //             max={3}
    //             onChange={onEtcFileChange}
    //           />
    //         </div>
    //       ),
    //     },
    //   ],
    // },
  ];

  const informationForm = [
    {
      label: '대표자명',
      form: [
        {
          input: (
            <Input
              size="large"
              value={informationValue.store_owner}
              onChange={(e) =>
                onChange(
                  'store_owner',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              placeholder="대표자명을 입력해주세요"
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '매장 연락처',
      form: [
        {
          input: (
            <Input
              size="large"
              value={informationValue.store_num}
              onChange={(e) =>
                onChange(
                  'store_num',
                  Formatter.numberOnly(e.target.value, 'hyphen'),
                  informationValue,
                  setInformationValue
                )
              }
              placeholder="매장 연락처를 입력해주세요"
              showCount
              count={{
                max: 13,
                show: true,
              }}
              maxLength={13}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '사업자등록번호',
      form: [
        {
          input: (
            <Input
              size="large"
              value={informationValue.business_num}
              onChange={(e) =>
                onChange(
                  'business_num',
                  Formatter.hyphen(e.target.value, 'business_num'),
                  informationValue,
                  setInformationValue
                )
              }
              placeholder="사업자등록번호를 입력해주세요"
              count={{
                max: 12,
                show: true,
              }}
              maxLength={12}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '영업시간',
      form: [
        {
          input: (
            <Input.TextArea
              size="large"
              value={informationValue.business_hour}
              onChange={(e) =>
                onChange(
                  'business_hour',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              placeholder="영업시간을 입력해주세요"
              style={{ ...styles.form.input.large, width: 500, height: 150 }}
            />
          ),
        },
      ],
    },
    {
      label: '화장실 정보',
      form: [
        {
          input: (
            <Input
              size="large"
              value={inputValue.toilet_information}
              onChange={(e) =>
                onChange(
                  'toilet_information',
                  e.target.value,
                  inputValue,
                  setInputValue
                )
              }
              placeholder="화장실 정보를 입력해주세요"
              style={{ width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: 'WIFI 정보',
      form: [
        {
          input: (
            <Input
              size="large"
              value={inputValue.wifi_information}
              onChange={(e) =>
                onChange(
                  'wifi_information',
                  e.target.value,
                  inputValue,
                  setInputValue
                )
              }
              placeholder="WIFI 정보를 입력해주세요"
              style={{ width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '단체 이용',
      form: [
        {
          input: (
            <Radio.Group
              options={[
                { label: '가능', value: true },
                { label: '불가능', value: false },
              ]}
              onChange={(e) =>
                onChange(
                  'GROUP',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              value={informationValue.GROUP}
              optionType="button"
              buttonStyle="solid"
            />
          ),
        },
      ],
    },
    {
      label: 'WIFI 이용',
      form: [
        {
          input: (
            <Radio.Group
              options={[
                { label: '가능', value: true },
                { label: '불가능', value: false },
              ]}
              onChange={(e) =>
                onChange(
                  'WIFI',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              value={informationValue.WIFI}
              optionType="button"
              buttonStyle="solid"
            />
          ),
        },
      ],
    },
    {
      label: '주차 이용',
      form: [
        {
          input: (
            <Radio.Group
              options={[
                { label: '가능', value: true },
                { label: '불가능', value: false },
              ]}
              onChange={(e) =>
                onChange(
                  'PARKING',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              value={informationValue.PARKING}
              optionType="button"
              buttonStyle="solid"
            />
          ),
        },
      ],
    },
    {
      label: '포장 이용',
      form: [
        {
          input: (
            <Radio.Group
              options={[
                { label: '가능', value: true },
                { label: '불가능', value: false },
              ]}
              onChange={(e) =>
                onChange(
                  'PACKAGING',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              value={informationValue.PACKAGING}
              optionType="button"
              buttonStyle="solid"
            />
          ),
        },
      ],
    },
    {
      label: '휠체어 이용',
      form: [
        {
          input: (
            <Radio.Group
              options={[
                { label: '가능', value: true },
                { label: '불가능', value: false },
              ]}
              onChange={(e) =>
                onChange(
                  'WHEELCHAIR',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              value={informationValue.WHEELCHAIR}
              optionType="button"
              buttonStyle="solid"
            />
          ),
        },
      ],
    },
    {
      label: '남녀 화장실 구분 여부',
      form: [
        {
          input: (
            <Radio.Group
              options={[
                { label: '구분', value: true },
                { label: '비구분', value: false },
              ]}
              onChange={(e) =>
                onChange(
                  'RESTROOM',
                  e.target.value,
                  informationValue,
                  setInformationValue
                )
              }
              value={informationValue.RESTROOM}
              optionType="button"
              buttonStyle="solid"
            />
          ),
        },
      ],
    },
  ];

  const adminForm = [
    {
      label: '관리자명',
      required: true,
      form: [
        {
          input: (
            <Input
              ref={nameRef}
              size="large"
              value={adminInfo.admin_name}
              onChange={(e) =>
                onChange('admin_name', e.target.value, adminInfo, setAdminInfo)
              }
              placeholder="관리자명을 입력해주세요"
              showCount
              count={{
                max: 5,
                show: true,
              }}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '아이디',
      required: true,
      form: [
        {
          input: (
            <Input
              ref={accountRef}
              size="large"
              value={adminInfo.admin_account}
              onChange={(e) =>
                onChange(
                  'admin_account',
                  Formatter.restrictKorean(e.target.value),
                  adminInfo,
                  setAdminInfo
                )
              }
              placeholder="아이디를 입력해주세요"
              showCount
              count={{
                max: 20,
                show: true,
              }}
              style={{ ...styles.form.input.large, width: 410 }}
            />
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.button }}
              onClick={() => onDuplication()}
            >
              중복검사
            </Button>
          ),
        },
      ],
    },
    {
      label: '비밀번호',
      required: true,
      form: [
        {
          input: (
            <Input.Password
              ref={passwordRef}
              size="large"
              value={adminInfo.password}
              onChange={(e) =>
                onChange('password', e.target.value, adminInfo, setAdminInfo)
              }
              placeholder="비밀번호를 입력해주세요"
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '비밀번호 확인',
      required: true,
      form: [
        {
          input: (
            <Input.Password
              ref={rePasswordRef}
              size="large"
              value={adminInfo.re_password}
              onChange={(e) =>
                onChange('re_password', e.target.value, adminInfo, setAdminInfo)
              }
              placeholder="비밀번호를 한번 더 입력해주세요"
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '연락처',
      required: true,
      form: [
        {
          input: (
            <Input
              ref={phoneRef}
              size="large"
              value={adminInfo.admin_phone}
              onChange={(e) =>
                onChange(
                  'admin_phone',
                  Formatter.hyphen(e.target.value),
                  adminInfo,
                  setAdminInfo
                )
              }
              placeholder="연락처를 입력해주세요"
              count={{
                max: 13,
                show: true,
              }}
              style={{ ...styles.form.input.large, width: 500 }}
            />
          ),
        },
      ],
    },
    {
      label: '이메일',
      required: true,
      form: [
        {
          input: (
            <Input
              ref={emailRef}
              size="large"
              value={adminInfo.admin_email}
              onChange={(e) =>
                onChange('admin_email', e.target.value, adminInfo, setAdminInfo)
              }
              placeholder="이메일을 입력해주세요"
              style={{ ...styles.form.input.large, width: 235 }}
            />
          ),
        },
        {
          input: <p>@</p>,
        },
        {
          input: (
            <Input
              size="large"
              value={adminInfo.admin_email_address}
              onChange={(e) =>
                onChange(
                  'admin_email_address',
                  e.target.value,
                  adminInfo,
                  setAdminInfo
                )
              }
              placeholder="이메일을 입력해주세요"
              style={{ ...styles.form.input.large, width: 235 }}
              readOnly={address}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              options={emailAddress}
              onChange={(e) => {
                setAddress(e);
                e !== '' &&
                  onChange('admin_email_address', e, adminInfo, setAdminInfo);
              }}
              value={address}
              style={{ ...styles.form.input.large, width: 235 }}
            />
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 검색 Popup Open
   * --
   */
  const handleOpen = () => {
    openAddressModal((res) => {
      onChange(
        'shop_information_postcode',
        res.zonecode,
        inputValue,
        setInputValue
      );
      onChange(
        'shop_information_address',
        res.address,
        inputValue,
        setInputValue
      );
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>매장 등록</Title>

          {/* 매장 기본 정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>매장 기본 정보</Title>
            <InputFormTable form={defaultForm} />
          </Content>
          {/* 매장 기본 정보 끝 */}

          {/* 매장 파일 정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>매장 파일 정보</Title>
            <InputFormTable form={infoFileForm} />
          </Content>
          {/* 매장 파일 정보 끝 */}

          {/* 매장 정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>매장 정보</Title>
            <InputFormTable form={informationForm} />
          </Content>
          {/* 매장 정보 끝 */}

          {/* 관리자 정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>관리자 정보</Title>
            <InputFormTable form={adminForm} />
          </Content>
          {/* 관리자 정보 끝 */}

          {/* 버튼 */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                  color: '#FFFFFF',
                }}
                onClick={() => onSubmit()}
              >
                저장
              </Button>
              <Button
                size="large"
                style={{ ...styles.button }}
                onClick={() => onCancel()}
              >
                취소
              </Button>
            </div>
          </Content>
          {/* 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default StoreRegisterPresenter;
